import Image from 'next/image';
import { FC } from 'react';

export type CtaSidebarDownloadProps = {
  image: string;
  ctaText: string;
  ctaHref: string;
}

const CtaSidebarDownload: FC<CtaSidebarDownloadProps> = ({
  image,
  ctaText = "Download Guide",
  ctaHref = "#",
}) => {


  return (
    <a href={ctaHref} className='text-blue-900 flex flex-col overflow-hidden group max-md:hidden'>
      {image && (
        <div className='relative overflow-hidden flex justify-center items-end'>
          <div className="bg-gray-100 block absolute w-full h-[calc(100%-72px)] rounded-[12px]"></div>
          <Image
            src={image}
            alt=""
            width={200}
            height={300}
            className='relative overflow-hidden w-[60%] mt-[15px] mb-[-15px] rounded-tl-[6px] rounded-tr-12 aspect-book object-cover transition-transform duration-800 ease-appear group-hover:translate-y-[-15px]'
          />
        </div>
      )}

      <div className='mt-3'>
        <span className='inline-flex items-center gap-1 text-blue-90 text-p2 font-500'>
          {ctaText}
          <span className="inline-block overflow-hidden relative">
            <span className="opacity-0">→</span>
            <span className='absolute left-0 top-0 inline-block transition-transform duration-800 ease-appear group-hover:translate-x-[101%]'>→</span>
            <span className='absolute left-0 top-0 inline-block transition-transform duration-800 ease-appear translate-x-[-101%] group-hover:translate-x-[0]'>→</span>
          </span>
        </span>
      </div>
    </a>
  );
}

export default CtaSidebarDownload;
